import {
  MdAutorenew,
  MdCampaign,
  MdCleaningServices,
  MdExtension,
  MdFlag,
  MdFormatListBulleted,
  MdGroup,
  MdOndemandVideo,
  MdSell,
  MdSettings,
  MdTrendingUp
} from 'react-icons/md';
import { AuditSection } from '@blisspointmedia/bpm-types/dist/GoogleAdsAudit';

export const GoogleAdsAuditTab = {
  SEARCH: 'search',
  RESULTS: 'results',
  ADMIN: 'admin'
} as const;
export type GoogleAdsAuditTabType = (typeof GoogleAdsAuditTab)[keyof typeof GoogleAdsAuditTab];

export const ResultsFilter = {
  ALL: 'all',
  LARGE: 'large',
  MEDIUM: 'medium',
  SMALL: 'small',
  OK: 'ok'
} as const;
export type ResultsFilterType = (typeof ResultsFilter)[keyof typeof ResultsFilter];

// Display order for the 11 audit sections — matches blisspoint-audit-agent's own check
// catalog (app/agent/audit/catalog/checks.json), since a single audit run now asks the
// agent for the full report in one call and its section grouping is the source of truth.
export const SECTION_ORDER: AuditSection[] = [
  'account_structure',
  'conversions',
  'audiences',
  'keywords',
  'creative',
  'assets_automated',
  'bidding_budgets',
  'campaign_settings',
  'cleanup',
  'automated_updates',
  'youtube_demand_gen'
];

export const SECTION_ICONS: Record<AuditSection, typeof MdFlag> = {
  account_structure: MdFormatListBulleted,
  conversions: MdFlag,
  audiences: MdGroup,
  keywords: MdSell,
  creative: MdCampaign,
  assets_automated: MdExtension,
  bidding_budgets: MdTrendingUp,
  campaign_settings: MdSettings,
  cleanup: MdCleaningServices,
  automated_updates: MdAutorenew,
  youtube_demand_gen: MdOndemandVideo
};

// Static "audit coverage" list shown on the landing page — 108 checks across 11
// sections, derived from blisspoint-audit-agent's own check catalog (not from live
// admin skill data, since the admin-editable skill count can drift from this baseline).
export const TOTAL_CHECK_COUNT = 108;
export const SECTION_CHECK_COUNTS: Record<AuditSection, number> = {
  account_structure: 13,
  conversions: 10,
  audiences: 11,
  keywords: 4,
  creative: 17,
  assets_automated: 8,
  bidding_budgets: 12,
  campaign_settings: 20,
  cleanup: 5,
  automated_updates: 7,
  youtube_demand_gen: 1
};
